import { AddNewLayerPayload, AssignSectorsToLayerPayload, AttributePayload, EditAndPublishLayerPayload, RestImportPayload, UniqueKeysPayload, UnpublishAndDeleteLayerPayload, StylesPayload } from "../types/layer";
import { baseInstance } from "axios/instances";

export const getLayersByRoleId = async (roleId: string) => {
    const res = await baseInstance.get(`/layers/${roleId}`);
    return res.data;
};

export const getLayersByRoleAndClient = async (roleId: string, clientId: string) => {
    const res = await baseInstance.get(`/layers/getlayerbyroleandclient/${roleId}/${clientId}`);
    return res.data;
};

export const getLayersByMap = async (mapId: string) => {
    const res = await baseInstance.get(`/layers/getlayerbymap/${mapId}`)
    return res.data
}

export const getLayersByMapAndClient = async (mapId: string, clientId: string) => {
    const res = await baseInstance.get(`/layers/getlayerbymapandclient/${mapId}/${clientId}`)
    return res.data
}

export const addMaplayers = async (mapLayerDetails: any) => {
    const res = await baseInstance.post(`/layers`, mapLayerDetails);
    return res.data;
};

export const uploadedShapeFiles = async (shapeFiles: any) => {
    const res = await baseInstance.post(`/upload-shapefile`, shapeFiles);
    return res.data;
};

export const addNewLayer = async (paylaod: AddNewLayerPayload) => {
    const res = await baseInstance.post(`/layermanagement/addnewLayer`, paylaod);
    return res.data;
};

export const geoserverStores = async (layerId: string) => {
    const res = await baseInstance.get(`/layermanagement/styles/checkStores/${layerId}`);
    return res.data;
};

export const publishLayers = async (layerDetails: any) => {
    const res = await baseInstance.post(`/publish_table`, layerDetails);
    return res.data;
};

export const unpublishLayer = async (payload: UnpublishAndDeleteLayerPayload) => {
    const res = await baseInstance.post(`/layermanagement/unpublishlayer`, payload);
    return res.data;
};

export const deleteLayer = async (payload: UnpublishAndDeleteLayerPayload) => {
    const res = await baseInstance.post(`/layermanagement/deletelayer`, payload);
    return res.data;
};

export const editAndPublishLayer = async (payload: EditAndPublishLayerPayload) => {
    const res = await baseInstance.post(`/layermanagement/editandpublishLayer`, payload);
    return res.data;
};

export const geoMapsLayersByClient = async (clientId: string) => {
    const res = await baseInstance.get(`/layermanagement/${clientId}`);
    return res.data;
};

export const getUniqueKeys = async (uniqueKeysPayload: UniqueKeysPayload) => {
    const res = await baseInstance.post("/collectiondata/getuniquekeys", uniqueKeysPayload)
    return res.data
}

export const getRuleSetValidatedLayers = async () => {
    const res = await baseInstance.get("/layerConfiguretion/getrulesetvalidationmapruleset/123")
    return res.data
}
export const getUnpublishedLayers = async (loginDetails: any) => {
    const res = await baseInstance.post(`/getunpublishedtables`, loginDetails);
    return res.data;
};

export const getLayersByClient = async (clientId: string) => {
    const res = await baseInstance.get(`/layermapping/getByClientId/${clientId}`);
    return res.data;
};

export const assignSectorsToLayer = async (paylaod: AssignSectorsToLayerPayload) => {
    const res = await baseInstance.post(`layermapping/add`, paylaod);
    return res.data;
};

export const updateSectorAssociationToLayer = async (payload: AssignSectorsToLayerPayload) => {
    const { layer_id, ...rest } = payload
    const res = await baseInstance.put(`layermapping/edit/${layer_id}`, rest);
    return res.data;
};

export const getAttributesByLayer = async (layerId: string) => {
    const res = await baseInstance.get(
        `/layerColumns/getLayerAttributesConfiguration/${layerId}`
    );
    return res.data;
};

export const updateAttributesByLayer = async (
    payload: AttributePayload
) => {
    const { layer_id, ...rest } = payload;
    const res = await baseInstance.post(
        `layerColumns/updateAttributesConfiguration/${layer_id}`,
        rest
    );
    return res.data;
};

export const getLayerExtent = async (layerName: string) => {
    const res = await baseInstance.get(`/layers/extent/${layerName}`);
    return res.data;
}

export const uploadStyles = async (payload: StylesPayload) => {
    const res = await baseInstance.post(`/layermanagement/styles/upload`, payload);
    return res.data;
}

export const getStylesbyGeometry = async (layerName: string) => {
    const res = await baseInstance.get(`layermanagement/styles/byGeometry/${layerName}`);
    return res.data;
}

export const assignStyleToLayer = async (payload: { styleName: string, layerName: string }) => {
    const res = await baseInstance.post(`/layermanagement/styles/assignStyleToLayer`, payload);
    return res.data;
}

export const setDefaultStyle = async (layerName: string) => {
    const res = await baseInstance.get(`layermanagement/styles/defaultStyle/${layerName}`);
    return res.data;
}
export const createRestImport = async (payload: RestImportPayload) => {
    const res = await baseInstance.post(`/dataset/import-job`, payload);
    return res.data;
}